import { render, staticRenderFns } from "./Outcome.vue?vue&type=template&id=2c0f529d"
import script from "./Outcome.vue?vue&type=script&lang=js"
export * from "./Outcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports